export enum DesignInputSpeakAs {
  addressCity = 'ADDRESS_CITY',
  addressStreet = 'ADDRESS_STREET',
  asIs = 'AS_IS',
  character = 'CHARACTER',
  company = 'COMPANY',
  currency = 'CURRENCY',
  date = 'DATE',
  digit = 'DIGIT',
  internet = 'INTERNET',
  name = 'NAME',
  number = 'NUMBER',
  phoneNumber = 'PHONE_NUMBER',
  phoneticSpelling = 'PHONETIC_SPELLING',
  phoneticWord = 'PHONETIC_WORD',
  phrase = 'PHRASE',
  spelling = 'SPELLING',
  text = 'TEXT',
  translationCode = 'TRANSLATION_CODE',
  time = 'TIME',
  word = 'WORD'
}
